import { Autocomplete, TextField } from '@mui/material';
import { FC, HTMLAttributes, Key, memo } from 'react';
import { PlaceEntity } from 'src/entities/placeEntity';

interface PlaceNameAutocompleteProps {
  id: string;
  label: string;
  places: PlaceEntity[];
  value: string;
  onNameChange: (name: string) => void;
  onPlaceSelect: (place: PlaceEntity | null) => void;
  loading?: boolean;
}

const PlaceNameAutocomplete: FC<PlaceNameAutocompleteProps> = memo(({
  id,
  label,
  places,
  value,
  onNameChange,
  onPlaceSelect,
  loading = false
}) => (
  <Autocomplete<PlaceEntity, false, false, true>
    freeSolo
    id={id}
    options={places}
    loading={loading}
    value={value}
    getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
    onChange={(_, selected) => {
      if (typeof selected === 'object' && selected !== null) onPlaceSelect(selected);
    }}
    onInputChange={(_, name, reason) => {
      // reset は props の値を入力欄へ写しただけで、利用者の操作ではない（ShipperAutocomplete と同じ）。
      // selectOption は直後の onChange が地点ごと渡すので、ここで自由入力として地点を外さない
      if (reason === 'reset' || reason === 'selectOption') return;

      onNameChange(name);
      onPlaceSelect(null);
    }}
    fullWidth
    renderOption={(props, option) => {
      const optionProps = { ...props } as HTMLAttributes<HTMLLIElement> & { key?: Key };
      delete optionProps.key;

      return <li key={option.id} {...optionProps}>{option.name}</li>;
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        margin="dense"
        type="text"
        fullWidth
        label={label}
        slotProps={{ inputLabel: { shrink: true } }}
      />
    )}
  />
));

export default PlaceNameAutocomplete;
